export const posthogState = { loaded: false };
